<template>
    <img :src="source" class="img-fluid" alt="VR image placeholder" />
</template>

<script>
export default {
    name: 'Pano',
    props: { source: { type: String, required: true } }
};
</script>
